/*
 *   File : App.js
 *   Author : https://evoqins.com
 *   Description : Main app routing without PrivateRoute
 *   Integrations : js-cookie
 *   Version : 1.0.0
 */

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";

//custom components
import { Login, ForgotPassword, AuthLayout } from "./Container/Auth";
import { Sidebar, Footer, Header } from "./Components/Navigation";
import { Dashboard } from "./Container/Home";
import { CreateCustomerMain, Customer, Detail } from "./Container/Customer";
import {
  Holdings,
  Order,
  Profile,
  InvestmentBasket,
  InvestmentGoals,
  IndvidualInvestment,
  AllSip,
  ExternalInvestmentImport,
} from "./Container/Customer/Helper";

import { TransactionDetail, Transactions } from "./Container/Orders/index";
import { AddQuestion, ManageQuiz } from "./Container/ManageRiskScore/index";
import {
  EditRisk,
  EditRiskScores,
  RiskFundManagement,
} from "./Container/Manage General/index";
import { ContentManagement } from "./Container/ContentManagement/index";
import {
  AddBanner,
  AddBlog,
  AddNotification,
  Banner,
  Blog,
  EditStatic,
  FAQ,
  FaqQuestion,
  PushNotifications,
  Static,
} from "./Container/ContentManagement/Helper/";
import {
  AddAdmin,
  AddModules,
  AdminDetail,
  ManageSubAdmin,
} from "./Container/ManageSubAdmins/index";
import {
  AddBasket,
  ManageBasket,
  ManageDetail,
  ViewRebalanceHistory,
} from "./Container/ManageBasket/index";
import {
  AddGoal,
  ManageGoal,
  ManageGoalDetail,
  RebalancingHistory,
} from "./Container/Manage Goal";
import { SipBook } from "./Container/Sip Book";
import { NotificationList } from "./Container/Notifications Tab";
import { APIService } from "./Service";
import { Loader, ScrollToTop } from "./Components/Other";
import { ManageExploreFund } from "./Container/ManageExploreFund";

function App() {
  const [token, setToken] = useState(Cookies.get("access_token"));
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [title, setTitle] = useState("Welcome back, Admin");
  const [openLogoutMenu, setOpenLogoutMenu] = useState(false);
  // const [notification, setNotification] = useState();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    // setLoading(true);
    if (token) {
      _getMessagesCount();
    }
    if (
      token &&
      (window.location.pathname === "/login" ||
        window.location.pathname === "/forgot-password")
    )
      window.location.replace("/");
    setToken(Cookies.get("access_token"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _getMessagesCount = () => {
    const is_post = false;
    setLoading(true);
    APIService(is_post, "notification/count")
      .then((response) => {
        if (response.status_code === 200) {
          dispatch({
            type: "UPDATE_NOTIFICATION_COUNT",
            payload: response.data.notification_count,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div>
      {loading && (
        <Loader
          className={
            "min-vh-100 d-flex justify-content-center align-items-center"
          }
          width={30}
        />
      )}
      <Router>
        {token && !loading ? (
          <div className="container-fluid min-vh-100">
            <ScrollToTop />
            <div className="p-1">
              <div className="row">
                <div
                  className={`${isMenuOpen ? " col-2  " : "col-1"
                    } d-xl-block  d-none  p-0`}
                >
                  {/* <Suspense fallback={<div>loading...</div>}> */}
                  <Sidebar toggle={isMenuOpen} setTitle={setTitle} />
                  {/* </Suspense> */}
                </div>
                <div
                  className={`${isMenuOpen ? " col-xl-10  col-12" : "col-xl-11 col-12"
                    } min-vh-100  d-flex flex-column`}
                >
                  <div className="row ps-4">
                    {/* <Suspense fallback={<div>loading...</div>}> */}
                    <Header
                      title={title}
                      setOpenMenu={setOpenLogoutMenu}
                      openMenu={openLogoutMenu}
                      setTitle={setTitle}
                      setToken={setToken}
                      menuOpen={isMenuOpen}
                      handleToggle={setIsMenuOpen}
                    // notification={notification}
                    />
                    {/* </Suspense> */}
                  </div>
                  {/* <Suspense fallback={<div>loading...</div>}> */}
                  <div
                    onClick={() => setOpenLogoutMenu(false)}
                    className="flex-grow-1 "
                  >
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route
                        path="/notifications"
                        element={<NotificationList />}
                      />
                      <Route
                        path="/manage-sub-admin"
                        element={<ManageSubAdmin />}
                      />
                      <Route
                        path="/manage-sub-admin/modules"
                        element={<ManageSubAdmin />}
                      />
                      <Route
                        path="/manage-sub-admin/add-modules"
                        element={<AddModules />}
                      />
                      <Route
                        path="/manage-sub-admin/edit-modules/:id"
                        element={<AddModules />}
                      />
                      <Route
                        path="/manage-sub-admin/add-sub-admin"
                        element={<AddAdmin />}
                      />
                      <Route
                        path="/manage-sub-admin/edit-sub-admin/:id"
                        element={<AddAdmin />}
                      />
                      <Route
                        path="/manage-sub-admin/admin-detail/:id"
                        element={<AdminDetail />}
                      />
                      <Route path="/sip-book" element={<SipBook />} />
                      <Route path="/orders" element={<Transactions />} />
                      <Route
                        path="/orders/detail/:order_id"
                        element={<TransactionDetail />}
                      />
                      <Route path="/risk-profiling" element={<ManageQuiz />} />
                      <Route
                        path="/risk-profiling/add"
                        element={<ManageQuiz />}
                      />
                      <Route
                        path="/risk-profiling/edit/:Q_id"
                        element={<AddQuestion />}
                      />
                      <Route path="/customer" element={<Customer />} />
                      <Route
                        path="/customer/create-customer"
                        element={<CreateCustomerMain />}
                      />
                      <Route path="/customer/detail/:id" element={<Detail />}>
                        <Route index path="profile" element={<Profile />} />
                        <Route path="orders" element={<Order />} />
                        <Route path="holdings" element={<Holdings />} />
                        <Route
                          path="investment-basket"
                          element={<InvestmentBasket />}
                        />
                        <Route
                          path="investment-goods"
                          element={<InvestmentGoals />}
                        />
                        <Route
                          path="individual-fund-investment"
                          element={<IndvidualInvestment />}
                        />
                        <Route path="all-sip" element={<AllSip />} />
                        <Route
                          path="external-investment-import"
                          element={<ExternalInvestmentImport />}
                        />
                      </Route>
                      <Route path="/manage-explore-fund" element={<ManageExploreFund />} />
                      <Route path="/manage-basket" element={<ManageBasket />} />
                      <Route
                        path="/manage-basket/add"
                        element={<AddBasket />}
                      />
                      <Route
                        path="/manage-basket/detail/:id"
                        element={<ManageDetail />}
                      />
                      <Route
                        path="/manage-basket/view-rebalance"
                        element={<ViewRebalanceHistory />}
                      />
                      <Route
                        path="/manage-general"
                        element={<RiskFundManagement />}
                      />
                      <Route
                        path="/manage-general/edit"
                        element={<EditRisk />}
                      />
                      <Route
                        path="/manage-general/edit-scores"
                        element={<EditRiskScores />}
                      />

                      <Route
                        path="/content-management"
                        element={<ContentManagement />}
                      >
                        <Route index path="banners" element={<Banner />} />
                        <Route path="faq" element={<FAQ />} />
                        <Route path="static-pages" element={<Static />} />
                        <Route path="static-pages" element={<Static />} />
                        <Route path="blog" element={<Blog />} />
                        <Route
                          path="push-notifications"
                          element={<PushNotifications />}
                        />
                      </Route>
                      <Route path="/blog/add-blog" element={<AddBlog />} />
                      <Route path="/blog/edit-blog/:id" element={<AddBlog />} />
                      <Route
                        path="/faq/add-question"
                        element={<FaqQuestion />}
                      />
                      <Route
                        path="/faq/edit-question/:id"
                        element={<FaqQuestion />}
                      />
                      <Route
                        path="/static-pages/edit-static/:id"
                        element={<EditStatic />}
                      />
                      <Route
                        path="/push-notifications/add-notification"
                        element={<AddNotification />}
                      />

                      <Route
                        path="/content-management/add-banner"
                        element={<AddBanner />}
                      />
                      <Route
                        path="/content-management/edit-banner/:banner_id"
                        element={<AddBanner />}
                      />

                      <Route path="/manage-goal" element={<ManageGoal />} />
                      <Route
                        path="/manage-goal/edit/:id"
                        element={<ManageGoalDetail />}
                      />
                      <Route path="/manage-goal/add" element={<AddGoal />} />
                      <Route
                        path="/manage-goal/view-rebalance"
                        element={<RebalancingHistory />}
                      />
                      <Route path="*" element={<div>404</div>} />

                      {/* <Route path="/manage-goal/add-goal" element={<AddGoal />} /> */}
                    </Routes>
                  </div>
                  {/* </Suspense> */}
                  <div className="px-2 py-3">
                    {/* <Suspense fallback={<div>loading...</div>}> */}
                    <Footer />
                    {/* </Suspense> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          !loading && (
            <div className="container-fluid min-vh-100 w-100 d-flex pt-5 justify-content-center e-auth-wrapper-gradient">
              <Routes>
                <Route element={<AuthLayout />}>
                  <Route path="/login" element={<Login />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="*" element={<Login />} />
                </Route>
              </Routes>
            </div>
          )
        )}
      </Router>

      <ToastContainer
        autoClose={3000}
        pauseOnHover={false}
        position="bottom-right"
      />
    </div>
  );
}

export default App;
